import type { AuthError } from '@/api/AuthError';
import { SignInApiClient } from '@/api/sign-in';
import { AuthResponseCodes } from '@/api/types';
import { useSignInStore } from '@/store/signInStore';

export const useSendIdentifierOtp = () => {
  const updateSession = useSignInStore((s) => s.updateSession);

  return async (sendByVoice?: boolean) => {
    try {
      const response = await SignInApiClient.sendOTP(sendByVoice);
      updateSession({ transactionId: response.transactionId });
      return true;
    } catch (err) {
      if ((err as AuthError).code === AuthResponseCodes.OTP_SEND_ERROR) {
        return false;
      }
      throw err;
    }
  };
};
